import { NavigationMenuItem } from "@idw-types/common";
import { NavigationMenuListItem } from "../navigation-menu-list-item/navigation-menu-list-item";
import { NavigationMenuList } from "../navigation-menu-list/navigation-menu-list";

type NavigationMenuListContainerProps = {
    handleExpandVerticallyClick: () => void;
    collapsedHorizontally: boolean;
    item: NavigationMenuItem;
    depthLevel: number;
};

export const NavigationMenuListContainer = (props: NavigationMenuListContainerProps) => {
    const { handleExpandVerticallyClick, collapsedHorizontally, item, depthLevel } = props;

    return item.children ? (
        <NavigationMenuList
            handleExpandVerticallyClick={handleExpandVerticallyClick}
            collapsedHorizontally={collapsedHorizontally}
            item={item}
            depthLevel={depthLevel}
        />
    ) : (
        <NavigationMenuListItem
            collapsedHorizontally={collapsedHorizontally}
            item={item}
            depthLevel={depthLevel}
            expanded={false}
        />
    );
};